import React, { FC, useMemo } from 'react';

import { useBusinessUnitSelector } from '../../hooks/UseBusinessUnitSelector';
import { NavigationMenu } from '../navigation-menu/NavigationMenu';

import './BusinessUnitSelector.scss';

export const BusinessUnitSelector: FC = () => {
	const { options, selectedValue, handleSelectionChange, isReady } = useBusinessUnitSelector();

	const sortedOptions = useMemo(() => {
		const selected = options.find((o) => o.value === selectedValue?.value);
		const rest = options
			.filter((o) => o.value.toLowerCase() !== selectedValue?.value.toLowerCase())
			.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
		return selected ? [selected, ...rest] : rest;
	}, [options, selectedValue]);

	// Only render when we have a unitId (after redirect completes)
	if (!isReady) {
		return null;
	}

	return (
		<div className="business-unit-selector">
			<NavigationMenu
				id="business-unit-selector"
				options={sortedOptions}
				selectedValue={selectedValue}
				onSelectChange={handleSelectionChange}
				placeholder="Select a business unit"
				ariaLabel="Business unit navigation menu"
				className="business-unit-select"
			/>
		</div>
	);
};
